import {useQuery} from '@tanstack/react-query';

import {getOnboardings} from '../api';
import {QUERY__ONBOARDINGS} from '../queryKeys';

export const useGetOnboardings = () => {
  return useQuery({
    queryKey: [QUERY__ONBOARDINGS],
    queryFn: getOnboardings,
  });
};
